// Classic › gallery: the Gallery, Blog, content page and sponsor page copy
// (#1119). Page names (Gallery, Blog) and Try Again come from site-core.
import { plural } from '../../../plural'

const en = {
  backHome: 'Back to Home',
  gallery: {
    allSeasons: 'All Seasons',
    teamFilter: 'Team',
    allTeams: 'All Teams',
    playerFilter: 'Player',
    allPlayers: 'All Players',
    /** With filters on: how many images match. */
    found: (n: number) => plural(n, { one: `${n} image found`, other: `${n} images found` }),
    clearFilters: 'Clear filters',
    noPhotos: 'No photos found',
    clearAndRetry: 'Clear filters and try again',
    previous: 'Previous',
    next: 'Next',
    pageOf: (page: number, pages: number) => `Page ${page} of ${pages}`,
  },
  blog: {
    /** The default intro (a league can write its own). */
    intro: (leagueName: string) => `News, announcements, and updates from ${leagueName}`,
    loadError: 'Error Loading Posts',
    emptyTitle: 'No Posts Yet',
    emptyBody: (leagueName: string) => `Check back soon for news and updates from ${leagueName}.`,
    readMore: 'Read More',
    /** Under the grid: "Showing 1–9 of 24 posts". */
    showing: (from: number, to: number, total: number) => `Showing ${from}–${to} of ${total} posts`,
  },
  page: {
    notFoundTitle: 'Page Not Found',
    loadError: 'Error Loading Page',
    notFoundBody: "The page you're looking for doesn't exist or has been removed.",
    goHome: 'Go Home',
    notFound: 'Page not found.',
    publishedOn: (date: string) => `Published on ${date}`,
    empty: 'This page has no content yet.',
  },
  sponsor: {
    notFoundTitle: 'Sponsor Not Found',
    notFoundBody: 'This sponsor does not exist',
    back: 'Back',
    /** The tier badge: "Gold Sponsor". */
    level: (level: string) => `${level} Sponsor`,
    about: 'About',
    links: 'Links',
    /** null: the league's name hasn't loaded. */
    thanks: (leagueName: string | null) => `Thank you to our sponsors for supporting ${leagueName ?? 'the league'}!`,
  },
}

export default en
